import { render, staticRenderFns } from "./add-debit-card.component.vue?vue&type=template&id=1d476f22&"
import script from "./add-debit-card.component.vue?vue&type=script&lang=ts&"
export * from "./add-debit-card.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports